import React from 'react';
import { Box } from '@styleseat/ui';
import { BodyText } from '../../../ui';

type ContactListGroupHeaderProps = {
  text: string;
  style?: object;
};

/**
 * Generates a section heading with the provided text
 * @param {String} text - what to display
 * @param {Object} style
 */
export const ContactListGroupHeader = ({
  text,
  style,
}: ContactListGroupHeaderProps): JSX.Element => (
  <Box
    style={style}
    paddingLeft={20}
    paddingY={8}
    testID={`contacts-list-header-${text}`}
  >
    <BodyText
      appearance="small"
      weight="bold"
    >
      {text.toUpperCase()}
    </BodyText>
  </Box>
);

export default ContactListGroupHeader;
